import { useEffect } from 'react';
import { ColorMap } from '@abyss/3d-viewer';
import { useAtomValue } from 'jotai';
import { NONSELECTED_DEFECT_COLOR, TRANSPARENT_COLOR } from '@/constants';

import * as state from '@/components/Analysis/state';
import { colorWithAlpha, convertColorHexStringToNumber } from '@/utils';

export const useDefectColorEffects = (defectColorMaps: Record<string, ColorMap> | undefined) => {
  const structureDefects = useAtomValue(state.selectedStructureDefectsLegends);
  const nonSelectedDefectsIsEnabled = useAtomValue(state.nonSelectedDefectsIsEnabled);
  const blendOpacity = useAtomValue(state.blendOpacity);

  useEffect(() => {
    const nonSelectedColor = nonSelectedDefectsIsEnabled
      ? colorWithAlpha(NONSELECTED_DEFECT_COLOR, blendOpacity)
      : TRANSPARENT_COLOR;
    structureDefects?.forEach(({ isEnabled, color, octreeKey, octreeValue }) => {
      const convertedColor = convertColorHexStringToNumber(color);
      const colorMap = defectColorMaps?.[octreeKey.toLowerCase()];
      if (colorMap) {
        const unselectedColor = nonSelectedColor;
        colorMap.setColor(octreeValue, isEnabled ? convertedColor : unselectedColor);
      }
    });
  }, [defectColorMaps, structureDefects, nonSelectedDefectsIsEnabled, blendOpacity]);
};
